document.addEventListener('DOMContentLoaded', function () {
    // Check if debugging is enabled
    const debugEnabled = window.newsletter_popup_debug === true || window.newsletter_popup_debug === 'true';
    
    const debug = (message, data = null) => {
        if (debugEnabled) {
            if (data) {
                console.log(message, data);
            } else {
                console.log(message);
            }
        }
    };

    debug('🔥 Newsletter Popup Debug - Script Starting');
    
    const newsletterPopup = document.querySelector('.ticket-popup');
    const newsletterBackdrop = document.querySelector('.ticket-popup__lightbox');
    const closeButton = document.querySelector('.ticket-popup__close');
    const STORAGE_KEY_CLOSED = 'newsletter_popup_closed';
    const STORAGE_KEY_SUBMITTED = 'newsletter_popup_submitted';
    const PAGE_COUNT_KEY = 'page_visit_count';

    debug('🔍 DOM Elements Found:', {
        'newsletterPopup': !!newsletterPopup,
        'newsletterBackdrop': !!newsletterBackdrop,
        'closeButton': !!closeButton
    });

    // Increment page visit count
    let pageVisitCount = parseInt(localStorage.getItem(PAGE_COUNT_KEY)) || 0;
    pageVisitCount++;
    localStorage.setItem(PAGE_COUNT_KEY, pageVisitCount);

    // Get configuration from PHP
    let visitedPages = 1; // Default fallback
    if (typeof window.number_of_pages_condition_to_show !== 'undefined') {
        visitedPages = parseInt(window.number_of_pages_condition_to_show, 10);
    }
    
    const isEnabled = window.newsletter_popup_enabled === true || window.newsletter_popup_enabled === 'true';
    const formId = window.newsletter_popup_form_id ? parseInt(window.newsletter_popup_form_id, 10) : 0;

    debug('📊 Configuration Values:', {
        'pageVisitCount': pageVisitCount,
        'visitedPages': visitedPages,
        'isEnabled': isEnabled,
        'formId': formId,
        'debugEnabled': debugEnabled,
        'excludedPosts': window.popup_excluded_posts,
        'currentPostId': window.current_post_id,
        'raw_enabled': window.newsletter_popup_enabled,
        'raw_condition': window.number_of_pages_condition_to_show,
        'raw_form_id': window.newsletter_popup_form_id,
        'raw_debug': window.newsletter_popup_debug
    });

    // Check localStorage flags
    const hasBeenClosed = localStorage.getItem(STORAGE_KEY_CLOSED);
    const hasBeenSubmitted = localStorage.getItem(STORAGE_KEY_SUBMITTED);
    
    debug('💾 LocalStorage State:', {
        'closed': hasBeenClosed,
        'submitted': hasBeenSubmitted,
        'page_count': localStorage.getItem(PAGE_COUNT_KEY)
    });

    // Check individual conditions
    const isPageExcluded = (typeof window.popup_excluded_posts !== 'undefined' && 
                           typeof window.current_post_id !== 'undefined' && 
                           window.popup_excluded_posts.includes(window.current_post_id));
    
    const conditions = {
        'enabled': isEnabled,
        'pageCountMet': pageVisitCount >= visitedPages,
        'notClosed': !hasBeenClosed,
        'notSubmitted': !hasBeenSubmitted,
        'popupExists': !!newsletterPopup,
        'pageNotExcluded': !isPageExcluded
    };

    debug('✅ Condition Checks:', conditions);

    // Check if the popup should be shown
    const shouldShowPopup = isEnabled && 
                           pageVisitCount >= visitedPages && 
                           !localStorage.getItem(STORAGE_KEY_CLOSED) && 
                           !localStorage.getItem(STORAGE_KEY_SUBMITTED) &&
                           !isPageExcluded;

    debug('🎯 Final Decision:', {
        'shouldShowPopup': shouldShowPopup,
        'willShow': shouldShowPopup && newsletterPopup
    });

    if (shouldShowPopup && newsletterPopup) {
        debug('🚀 Showing popup in 1 second...');
        // Show popup after a small delay
        setTimeout(() => {
            if (window.matchMedia("(max-width: 768px)").matches) {
                jQuery(".ticket-popup, .ticket-popup__lightbox").fadeIn(600);
            } else {
                jQuery(".ticket-popup").fadeIn(600);
            }
            debug('✨ Popup is now visible');
        }, 1000);
    } else {
        debug('❌ Popup will NOT show. Reasons:', Object.entries(conditions).filter(([key, value]) => !value));
    }

    // Handle close button click
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            debug('🚪 Close button clicked');
            if (window.matchMedia("(max-width: 768px)").matches) {
                jQuery(".ticket-popup, .ticket-popup__lightbox").fadeOut();
            } else {
                jQuery(".ticket-popup").fadeOut();
            }
            localStorage.setItem(STORAGE_KEY_CLOSED, 'true');
        });
    }

    // Handle backdrop click to close popup
    if (newsletterBackdrop) {
        newsletterBackdrop.addEventListener('click', () => {
            debug('🌫️ Backdrop clicked');
            jQuery(".ticket-popup, .ticket-popup__lightbox").fadeOut();
            localStorage.setItem(STORAGE_KEY_CLOSED, 'true');
        });
    }

    // Handle Gravity Forms submission success
    if (formId > 0) {
        jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
            const targetFormId = window.newsletter_popup_form_id ? parseInt(window.newsletter_popup_form_id, 10) : 0;
            debug('📨 Gravity Forms confirmation loaded:', {
                'eventFormId': formId,
                'targetFormId': targetFormId,
                'matches': formId == targetFormId
            });
            if (formId == targetFormId && newsletterPopup) {
                debug('🎉 Newsletter popup form submitted successfully');
                
                // Get the Gravity Forms confirmation message
                const confirmationMessage = document.querySelector('#gform_confirmation_message_' + formId + ' div, .gform_confirmation_message');
                let confirmationText = 'Thank you for subscribing!';
                
                if (confirmationMessage) {
                    confirmationText = confirmationMessage.innerHTML || confirmationMessage.textContent || confirmationText;
                    debug('📝 Found confirmation message:', confirmationText);
                }
                
                // Replace popup content with confirmation message
                jQuery(".ticket-popup__content").html(`
                    <div class="ticket-popup__confirmation">
                        <div class="ticket-popup__confirmation__content">${confirmationText}</div>
                    </div>
                `);
                
                jQuery(".ticket-popup__holder").css("align-items", "center");
                
                localStorage.setItem(STORAGE_KEY_SUBMITTED, 'true');
                
                // Hide popup after 4 seconds
                setTimeout(() => {
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        jQuery(".ticket-popup, .ticket-popup__lightbox").fadeOut(800);
                    } else {
                        jQuery(".ticket-popup").fadeOut(800);
                    }
                    debug('🗑️ Newsletter popup hidden after form submission');
                }, 4000);
            }
        });
    } else {
        debug('⚠️ No form ID configured for Gravity Forms integration');
    }
});

